var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacultyBadges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.019 512.019",
    style: {
      enableBackground: "new 0 0 512.019 512.019"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M405.343,0H106.676C100.785,0,96.01,4.776,96.01,10.667v490.667  c-0.011,5.891,4.757,10.675,10.648,10.686c2.84,0.005,5.565-1.123,7.571-3.134L256.01,367.083l141.781,141.781  c4.16,4.171,10.914,4.179,15.085,0.019c2.006-2.001,3.133-4.717,3.134-7.55V10.667C416.01,4.776,411.234,0,405.343,0z",
    "data-original": "#2196F3",
    className: "",
    "data-old_color": "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2838"
    },
    d: "M367.604,145.067c-1.425-4.403-5.527-7.384-10.155-7.381h-69.76L266.143,71.36  c-2.48-5.602-9.032-8.134-14.634-5.654c-2.522,1.116-4.538,3.132-5.654,5.654l-21.547,66.325H154.57  c-5.891,0.07-10.609,4.902-10.539,10.793c0.039,3.313,1.616,6.419,4.267,8.407l56.512,41.109l-21.547,66.325  c-1.827,5.601,1.233,11.622,6.833,13.448c3.257,1.062,6.826,0.496,9.593-1.523l56.32-40.981l56.427,40.981  c4.759,3.472,11.432,2.427,14.904-2.332c2.019-2.768,2.585-6.336,1.523-9.593l-21.653-66.325l56.427-41.003  C367.409,154.301,369.013,149.482,367.604,145.067z",
    "data-original": "#FAFAFA",
    className: "active-path",
    "data-old_color": "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.343,512c-2.831,0.005-5.548-1.115-7.552-3.115L256.01,367.083L114.228,508.885c-4.16,4.171-10.914,4.179-15.085,0.019  c-2.011-2.006-3.139-4.731-3.134-7.571V10.667C96.01,4.776,100.785,0,106.676,0h298.667c5.891,0,10.667,4.776,10.667,10.667v490.667  C416.01,507.224,411.234,512,405.343,512z M256.01,341.333c2.831-0.005,5.548,1.115,7.552,3.115l131.115,131.136V21.333H117.343  v454.251l131.115-131.115C250.458,342.462,253.176,341.334,256.01,341.333z",
    "data-original": "#000000",
    className: "",
    style: {
      fill: "#FFFFFF"
    },
    "data-old_color": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.708,278.293c-2.264-0.027-4.461-0.775-6.272-2.133l-56.427-40.896l-56.427,40.981  c-4.759,3.472-11.432,2.427-14.904-2.332c-2.019-2.768-2.585-6.336-1.523-9.593l21.653-66.325l-56.512-41.003  c-4.713-3.534-5.669-10.22-2.135-14.933c1.988-2.651,5.094-4.227,8.407-4.267h69.76l21.547-66.325  c2.48-5.602,9.032-8.134,14.634-5.654c2.522,1.116,4.538,3.132,5.654,5.654l21.547,66.325h69.76  c5.891,0.07,10.609,4.902,10.539,10.793c-0.039,3.313-1.616,6.419-4.267,8.407l-56.533,41.003l21.547,66.325  c1.814,5.605-1.258,11.619-6.863,13.433c-1.063,0.344-2.174,0.519-3.292,0.519L318.708,278.293z M256.01,211.413  c2.264,0.027,4.461,0.775,6.272,2.133l36.139,26.24l-13.803-42.475c-1.426-4.396,0.141-9.211,3.883-11.925l36.139-26.261h-44.672  c-4.628,0.003-8.729-2.979-10.155-7.381l-13.803-42.56l-13.803,42.475c-1.425,4.403-5.527,7.384-10.155,7.381h-44.651l36.139,26.261  c3.741,2.714,5.309,7.529,3.883,11.925l-13.803,42.475l36.139-26.24C251.575,212.137,253.762,211.421,256.01,211.413z",
    "data-original": "#000000",
    className: "",
    style: {
      fill: "#FFFFFF"
    },
    "data-old_color": "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacultyBadges);
export default __webpack_public_path__ + "static/media/faculty-badges.cd0f85c863314170d74405e98d011329.svg";
export { ForwardRef as ReactComponent };